import React from "react";

export default ({ epic }) => {
  return (
    <div>
      <div className="p-2">
        <pre className="text-xs bg-gray-800 text-gray-100 rounded p-2">{JSON.stringify(epic, null, 2)}</pre>
      </div>
    </div>
  );
};
